/* eslint-disable import/no-anonymous-default-export */
import { RouteObject } from "react-router-dom";
import {
  CLIENT_CREATE,
  CLIENT_MANAGE,
  CLIENT_ONBOARDING_COMPANY,
  CLIENT_ONBOARDING_COMPLETE,
  CLIENT_ONBOARDING_EMPLOYEES,
  CLIENT_ONBOARDING_INVOICE,
  CLIENT_ONBOARDING_Licenses,
  CLIENT_ONBOARDING_PAYMENT,
  CLIENT_ONBOARDING_PRIMARY_ADMIN,
  CLIENT_ONBOARDING_STARTER_POINTS,
  CLIENT_PROFILE,
  CLIENT_RENEW_LICENCES,
} from "constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: CLIENT_MANAGE,
    lazy: () => import("./routes/ClientsList"),
  },
  {
    path: CLIENT_CREATE,
    lazy: () => import("./routes/ClientOnboardingCompany"),
  },
  {
    path: CLIENT_ONBOARDING_COMPANY,
    lazy: () => import("./routes/ClientOnboardingCompany"),
  },
  {
    path: CLIENT_ONBOARDING_PRIMARY_ADMIN,
    lazy: () => import("./routes/ClientOnboardingPrimaryAdmin"),
  },
  {
    path: CLIENT_ONBOARDING_EMPLOYEES,
    lazy: () => import("./routes/ClientOnboardingEmployees"),
  },
  {
    path: CLIENT_ONBOARDING_Licenses,
    lazy: () => import("./routes/ClientOnboardingLicenses"),
  },
  {
    path: CLIENT_ONBOARDING_STARTER_POINTS,
    lazy: () => import("./routes/ClientOnboardingStarterPoints"),
  },
  {
    path: CLIENT_ONBOARDING_INVOICE,
    lazy: () => import("./routes/ClientOnboardingInvoice"),
  },
  {
    path: CLIENT_ONBOARDING_PAYMENT,
    lazy: () => import("./routes/ClientOnboardingPayment"),
  },
  {
    path: CLIENT_ONBOARDING_COMPLETE,
    lazy: () => import("./routes/ClientOnboardingComplete"),
  },
  {
    path: CLIENT_PROFILE,
    lazy: () => import("./routes/ClientProfile"),
  },
  {
    path: CLIENT_RENEW_LICENCES,
    lazy: () => import("./routes/ClientRenewLicences"),
  },
] as RouteObject[];
